<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert')">Carl Von Schubert</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/egon-muller')">Egon Müller</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/jj-prum')">J.J. Prüm</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/peter-lauer')">Peter Lauer</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/van-volxem')">Van Volxem</nuxt-link>
                    <nuxt-link class="wine-guide-country two-line" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken')">Weingut Forstmeister Geltz Zilliken</nuxt-link>
                    <nuxt-link class="wine-guide-country two-line" :to="localePath('/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch')">Wwe. Dr. H. Thanisch, Erben Thanisch</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Carl Von Schubert</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Uno dei malintesi più diffusi è che tutti i Riesling tedeschi siano dolci. Mentre esso
                        è certamente vero che la tendenza per i Riesling da tavola è stata in passato più dolce,
                        come i jeans stone washed e le tute shell, non tutte le mode sono una buona idea. Tuttavia, le maree
                        stanno girando e un produttore si erge testa e spalle sopra il branco; Carlo Van Schubert.
                        Von Schubert produce vini asciutti, nitidi e meravigliosamente equilibrati
                        scelta quando si tratta di Riesling.
                    </div>

                    <div class="howto-title2">Un passato storico</div>
                    <div class="howto-text">
                        Riconosciuto come l'apoteosi del Riesling, Von Schubert è una tenuta con un passato. I vigneti
                        sono presenti almeno dal 661, quando sul terreno sorgeva un monastero benedettino. Questo
                        proseguì più o meno fino al 1810 quando Napoleone Bonaparte si impossessò del feudo. Nel 1881 la terra
                        andò all'asta e fu acquistata dal trisnonno dell'attuale proprietario. Dal 1981
                        la tenuta Von Schubert è stata gestita da Carl, la sesta generazione della famiglia.
                    </div>

                    <div class="howto-title2">Tradizione con un tocco</div>
                    <div class="howto-text">
                        Von Schubert ha mantenuto la tradizione e ha continuato a coltivare i tre storici benedettini
                        vigneti: Abstberg, Herrenberg e Bruderberg. Di questi, Maximin Grunhauser Abstberg è il
                        più noto, probabilmente perché (come suggerisce il nome), venivano serviti i vini di questo vigneto
                        esclusivamente all'Abate (o 'Abt'). Anche se i vini di Bruderberg lo sono stati storicamente
                        le tenute meno favorite, il cambiamento climatico ha avuto il suo (in questo caso gradito) effetto e
                        I vini Bruderberg hanno iniziato a raccogliere un seguito di culto, con la convinzione di alcuni investitori di Riesling
                        supererà presto l'Abstberg in qualità e longevità.
                    </div>

                    <div class="howto-title2">Punti e prezzi</div>
                    <div class="howto-text">
                        Incredibilmente un buon rapporto qualità-prezzo (i prezzi delle obbligazioni in Germania erano di € 50 per mezzo caso), crescita di
                        I vini Maximin Grunhauser sono stabili: circa il 10% anno su anno tra il 2017 e il 2019. Maximin 2015
                        Grünhäuser Herrenberg Riesling GG (90 punti sul punteggio complessivo, incluso un punteggio di 18,5/20 di
                        Jancis Robinson) supera di gran lunga altri 90 puntatori (come il 2013 o il 2016) e ha mostrato
                        picchi significativi nello stesso periodo di 2 mesi. I vini più dolci hanno l'invecchiamento più lungo
                        potenziale (ergo sono la migliore opzione investibile) e hanno prezzi da abbinare. cioè: Herrenberg
                        Il Riesling Trockenbeerenauslese ha una media di 2.171 € per mezza bottiglia.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Maximin Grünhäuser Abtsberg Riesling GG 2015: questo "cool Grosses Gewächs da un'estate calda" ha ricevuto 18/20 da Jancis Robinson.</li>
                            <li>2014 Maximin Grünhäuser Abtsberg Riesling Spätlese ha ricevuto 95 punti da Robert Parker Wine Advocate con una gamma di bevute dal 2030 al 2060, Stephan Reinhardt di RP ha notato che questo “ha bisogno di almeno 15 anni per rivelare i suoi veri talenti. Questo è un ottimo Spätlese in formato Grand Cru”. Valore incredibile con prezzi in media di € 25.</li>
                            <li>Nel dicembre 2017, Maximin Grünhäuser Abtsberg Riesling Beerenauslese 2015 si è classificato al 4° posto nella classifica dei "100 vini tedeschi del 2017" di James Suckling. Stuart Pigott ha proclamato 100 punti e “Aggrappati al tuo cappello! Un vino senza tempo.” Al comando di alcuni dei prezzi più alti di Ruwer, una singola bottiglia viene venduta a una media di € 420 ad aprile 2019.</li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Carl Von Schubert</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Eines der am weitesten verbreiteten Missverständnisse ist, dass alle deutschen Rieslinge süß seien. Während es
                        Es ist sicher richtig, dass der Trend bei Tafelrieslingen in der Vergangenheit eher zur süßeren Seite ging,
                        Wie zum Beispiel Stonewashed-Jeans und Shell-Anzüge sind nicht alle Modetrends eine gute Idee. Allerdings die Gezeiten
                        drehen sich, und ein Produzent steht der Masse um Längen voraus; Carl Van Schubert.
                        Von Schubert ist der Spezialist für knochentrockene, klar definierte und wunderbar ausgewogene Weine
                        Wahl, wenn es um Riesling geht.
                    </div>

                    <div class="howto-title2">Eine historische Vergangenheit</div>
                    <div class="howto-text">
                        Von Schubert gilt als die Apotheose des Rieslings und ist ein Weingut mit Vergangenheit. Die Weinberge
                        bestehen seit mindestens 661, als auf dem Gelände ein Benediktinerkloster stand. Das
                        dauerte mehr oder weniger bis 1810, als Napoleon Bonaparte das Anwesen beschlagnahmte. Im Jahr 1881 das Land
                        wurde versteigert und vom Ururgroßvater des jetzigen Besitzers erworben. Seit 1981
                        Das Weingut Von Schubert wird von Carl, der sechsten Generation der Familie, geführt.
                    </div>

                    <div class="howto-title2">Tradition mit dem gewissen Etwas</div>
                    <div class="howto-text">
                        Von Schubert ist der Tradition treu geblieben und hat die drei historischen Benediktiner weiter gepflegt
                        Weinberge: Abstberg, Herrenberg und Bruderberg. Davon ist Maximin Grünhauser Abstberg der
                        am bekanntesten, wahrscheinlich weil (wie der Name schon sagt) Weine aus diesem Weinberg serviert wurden
                        ausschließlich dem Abt (oder „Abt“). Auch wenn es Weine vom Bruderberg schon seit jeher gibt
                        Die am wenigsten begünstigten Ländereien, der Klimawandel hat seine (in diesem Fall willkommenen) Auswirkungen gehabt und
                        Einige Riesling-Investoren glauben, dass Bruderberg-Weine mittlerweile Kultstatus erlangen
                        Es wird den Abstberg bald an Qualität und Langlebigkeit übertreffen.
                    </div>

                    <div class="howto-title2">Punkte und Preise</div>
                    <div class="howto-text">
                        Unglaublich gutes Preis-Leistungs-Verhältnis (Anleihenpreise in Deutschland lagen bei 50 € für eine halbe Kiste), Wachstum von
                        Die Weine von Maximin Grunhauser sind stabil: etwa 10 % im Vergleich zum Vorjahr zwischen 2017 und 2019. 2015er Maximin
                        Grünhäuser Herrenberg Riesling GG (90 Punkte in der Gesamtwertung, darunter eine 18,5/20-Punktzahl von
                        Jancis Robinson) übertrifft andere 90-Punkte-Spieler (wie den 2013 oder den 2016) bei weitem und zeigte das
                        signifikante Spitzenwerte im gleichen 2-Monats-Zeitraum. Die süßeren Weine reifen am längsten
                        Potenzial haben (ergo sind sie die beste investierbare Option) und entsprechende Preise haben. d.h.: Herrenberg
                        Riesling Trockenbeerenauslese kostet durchschnittlich 2.171 € pro halbe Flasche.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>2015 Maximin Grünhäuser Abtsberg Riesling GG: Dieses „kühle Große Gewächs aus einem heißen Sommer“ erhielt 18/20 von Jancis Robinson.</li>
                            <li>2014 Maximin Grünhäuser Abtsberg Riesling Spätlese erhielt 95 Punkte von Robert Parker Wine Advocate mit einem Trinkbereich von 2030 bis 2060. Stephan Reinhardt von RP bemerkte, dass „mindestens 15 Jahre nötig sind, um sein wahres Talent zu offenbaren.“ Das ist eine tolle Spätlese im Grand-Cru-Format.“ Unglaublicher Wert mit Preisen von durchschnittlich 25 €.</li>
                            <li>Im Dezember 2017 belegte Maximin Grünhäuser Abtsberg Riesling Beerenauslese Platz 4 in James Sucklings Top „100 deutschen Weinen 2017“. Stuart Pigott verkündete 100 Punkte und „Halten Sie Ihren Hut fest! Ein zeitloser Wein.“ Mit einem der höchsten Preise in Ruwer wird eine einzelne Flasche im April 2019 für durchschnittlich 420 € verkauft.</li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Carl Von Schubert</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        L'une des idées fausses les plus répandues est que tous les rieslings allemands sont sucrés. Alors qu'il
                        est certainement vrai que la tendance des Rieslings de table a été dans le passé plutôt sucrée,
                        comme les jeans délavés et les costumes de coquille, toutes les modes ne sont pas une bonne idée. Cependant, les marées
                        tournent, et un producteur se tient tête et épaules au-dessus du peloton ; Carl Van Schubert.
                        Élaborant des vins secs, parfaitement définis et magnifiquement équilibrés, Von Schubert est le
                        choix en matière de Riesling.
                    </div>

                    <div class="howto-title2">Un passé historique</div>
                    <div class="howto-text">
                        Reconnu comme l'apothéose du Riesling, Von Schubert est un domaine avec un passé. Les vignes
                        sont en place depuis au moins 661 lorsqu'un monastère bénédictin se dressait sur le terrain. Ce
                        continua plus ou moins jusqu'en 1810 lorsque Napoléon Bonaparte s'empara du domaine. En 1881, la terre
                        est passé aux enchères et a été acquis par l'arrière-arrière-grand-père de l'actuel propriétaire. Depuis 1981
                        le domaine Von Schubert a été géré par Carl, la sixième génération de la famille.
                    </div>

                    <div class="howto-title2">La tradition revisitée</div>
                    <div class="howto-text">
                        Von Schubert a conservé la tradition et a continué à cultiver les trois bénédictins historiques
                        vignobles : Abstberg, Herrenberg et Bruderberg. Parmi eux, Maximin Grunhauser Abstberg est le
                        le plus connu, probablement parce que (comme son nom l'indique), les vins de ce vignoble étaient servis
                        exclusivement à l'Abbé (ou 'Abt'). Même si les vins du Bruderberg ont toujours été
                        les domaines les moins favorisés, le changement climatique a eu son effet (en l'occurrence le bienvenu) et
                        Les vins de Bruderberg ont commencé à devenir cultes, certains investisseurs de Riesling croyant
                        il dépassera bientôt l'Abstberg en qualité et en longévité.
                    </div>

                    <div class="howto-title2">Points et prix</div>
                    <div class="howto-text">
                        Rapport qualité-prix incroyablement bon (le prix des obligations en Allemagne était de 50 € pour une demi-caisse), croissance de
                        Les vins Maximin Grunhauser sont stables : autour de 10% sur un an entre 2017 et 2019. 2015s Maximin
                        Grünhäuser Herrenberg Riesling GG (90 points au total, dont 18,5/20 par
                        Jancis Robinson) dépasse de loin les autres 90 points (comme le 2013 ou le 2016) et a montré
                        pics significatifs au cours de la même période de 2 mois. Les vins les plus doux ont le plus long vieillissement
                        potentiel (ergo sont la meilleure option d'investissement) et ont des prix correspondants. c'est-à-dire : Herrenberg
                        Le Riesling Trockenbeerenauslese coûte en moyenne 2 171 € la demi-bouteille.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Riesling GG Maximin Grünhäuser Abtsberg 2015: ce «Grosses Gewächs frais d'un été chaud» a reçu la note de 18/20 de Jancis Robinson.</li>
                            <li>Le Maximin Grünhäuser Abtsberg Riesling Spätlese 2014 a reçu 95 points du Robert Parker Wine Advocate avec une plage de consommation allant de 2030 à 2060, Stephan Reinhardt de RP notant qu'il "a besoin d'au moins 15 ans pour révéler ses véritables talents. C'est un grand Spätlese au format Grand Cru. Une valeur incroyable avec des prix moyens de 25 €.</li>
                            <li>En décembre 2017, 2015 Maximin Grünhäuser Abtsberg Riesling Beerenauslese s'est classé n°4 dans le top « 100 German Wines of 2017 » de James Suckling. Stuart Pigott a proclamé 100 points et « Accrochez-vous à votre chapeau ! Un vin intemporel. Avec des prix parmi les plus élevés de Ruwer, une seule bouteille se vend en moyenne 420 € en avril 2019.</li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Carl Von Schubert</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        One of the most widely believed misconceptions is that all German Rieslings are sweet. While it
                        is certainly true that the trend for table Rieslings has in the past been on the sweeter side,
                        like stone washed jeans and shell suits, not all fashions are a good idea. However, the tides
                        are turning, and one producer stands head and shoulders above the pack; Carl Van Schubert.
                        Making bone-dry, crisply defined and beautifully balanced wines, Von Schubert is the people’s
                        choice when it comes to Riesling.
                    </div>

                    <div class="howto-title2">An historic past</div>
                    <div class="howto-text">
                        Recognised as the apotheosis of Riesling, Von Schubert is an estate with a past. The vineyards
                        have been in place since at least 661 when a Benedictine monastery stood on the land. This
                        continued more or less until 1810 when Napoleon Bonaparte seized the estate. In 1881 the land
                        went to auction and was acquired by the great-great-grandfather of the current owner. Since 1981
                        the Von Schubert estate has been managed by Carl, the sixth generation of the family.
                    </div>

                    <div class="howto-title2">Tradition with a twist</div>
                    <div class="howto-text">
                        Von Schubert has kept with tradition and continued cultivating the three historic Benedictine
                        vineyards: Abstberg, Herrenberg and Bruderberg. Of these, Maximin Grunhauser Abstberg is the
                        most well-known, probably because (as its name suggests), wines from this vineyard were served
                        exclusively to the Abbot (or 'Abt'). Even though wines from Bruderberg have historically been
                        the estates least favoured, climate change has had its (in this case welcome) effect and
                        Bruderberg wines have started to gather a cult following, with some Riesling investors believing
                        it will soon surpass the Abstberg in quality and longevity.
                    </div>

                    <div class="howto-title2">Points and prices</div>
                    <div class="howto-text">
                        Incredibly good value for money, (bond prices in Germany were €50 for a half-case), growth of
                        Maximin Grunhauser wines is stable: around 10% year on year between 2017 and 2019. 2015s Maximin
                        Grünhäuser Herrenberg Riesling GG (90 points on aggregate scoring, including a 18.5/20 score by
                        Jancis Robinson) far outstrips other 90-pointers (such as the 2013 or the 2016) and showed
                        significant peaks in the same 2-month period. The sweeter wines have the longest ageing
                        potential (ergo are the best investable option) and have prices to match. i.e.: Herrenberg
                        Riesling Trockenbeerenauslese averages €2,171 per half-bottle.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>2015 Maximin Grünhäuser Abtsberg Riesling GG: This “cool Grosses Gewächs from a hot summer” received 18/20 from Jancis Robinson.</li>
                            <li>2014 Maximin Grünhäuser Abtsberg Riesling Spätlese received 95 points from Robert Parker Wine Advocate with a drinking range 2030-2060, RP’s Stephan Reinhardt noting this “needs at least 15 years to reveal its true talents. This is a great Spätlese in Grand Cru format.” Incredible value with prices averaging €25.</li>
                            <li>In December 2017, 2015 Maximin Grünhäuser Abtsberg Riesling Beerenauslese ranked #4 in James Suckling’s top “100 German Wines of 2017”. Stuart Pigott proclaimed 100 points and “Hang on to your hat! A timeless wine.” Commanding some of the highest prices in Ruwer, a single bottle sells for an average of €420 in April 2019.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CarlVonSchubert",
    data() {
        return {
            select: {report: 'Carl Von Schubert', src: '/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert'},
            items: [
                {report: 'Carl Von Schubert', src: '/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert'},
                {report: 'Egon Müller', src: '/wine-guide/germany/mosel-saar-ruwer/egon-muller'},
                {report: 'J.J. Prüm', src: '/wine-guide/germany/mosel-saar-ruwer/jj-prum'},
                {report: 'Peter Lauer', src: '/wine-guide/germany/mosel-saar-ruwer/peter-lauer'},
                {report: 'Van Volxem', src: '/wine-guide/germany/mosel-saar-ruwer/van-volxem'},
                {
                    report: 'Weingut Forstmeister Geltz Zilliken',
                    src: '/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken'
                },
                {
                    report: 'Wwe. Dr. H. Thanisch, Erben Thanisch',
                    src: '/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Carl Von Schubert | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality of Carl von Schubert\'s wines, produced in the Mosel wine region. Experience the perfect blend of tradition and modern winemaking techniques in every bottle.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
